import { render, staticRenderFns } from "./BaseAvatar.vue?vue&type=template&id=a0b1dbbc&scoped=true&"
import script from "./BaseAvatar.vue?vue&type=script&lang=ts&"
export * from "./BaseAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAvatar.vue?vue&type=style&index=0&id=a0b1dbbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b1dbbc",
  null
  
)

export default component.exports